export default __webpack_public_path__ + "static/media/img_logo_large.82c8d186.png";